import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import './style.css';
import { useSelector } from 'react-redux';
import { ADDITIONAL_PROPS, MAX_FILE_SIZE, MULTIPART_INPUTS, TEXT_INPUTS } from './config';
import { useSnackbar } from 'notistack';
import { moderate } from '../../../util/request';
import { dispatchErr } from '../../../util/metamask';
import CircularProgress from '@mui/material/CircularProgress';

const AdditionalInformation = props => {

    const { enqueueSnackbar } = useSnackbar(),
    labels = useMemo( () => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    hasData = Boolean( props.value ),
    [ loading, setLoading ] = useState( false );

    /**
     * @name clearUpload
     * @function
     * @description Clears an uploaded file
     */
    const clearUpload = () => {
        props.onChange({ target: { name: props.dataKey,  value: '' } });
    }
    
    /**
     * @name handleUpload
     * @function
     * @description Removes the data item
     */
    const handleUpload = e => {
        const fr = new FileReader(),
        file = e.target.files[0],
        fileName = file.name;

        if( file.size > MAX_FILE_SIZE ){
            dispatchErr( { 
                message: labels.formatString(
                    labels.tooBig,
                    fileName
                )
            }, enqueueSnackbar );
        } else {

            setLoading( true );
            moderate( file, locale )
                .then( res => {
                    setLoading( false );
                    if( res.status === 200 ){

                        fr.addEventListener( 'load', () => {

                            props.onChange({ 
                                target: {
                                    name: props.dataKey, 
                                    value: fr.result
                                }
                            });
                        
                        });
                        fr.readAsDataURL( file );
                    } else {
                        dispatchErr( res, enqueueSnackbar, labels );
                    }
                })
                .catch( err => {
                    setLoading( false );
                    dispatchErr( err, enqueueSnackbar, labels );
                });
        
            e.target.value = '';
        }
           
    }


    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        <>
            {
                // text inputs
                TEXT_INPUTS.includes( props.type ) ?
                    <FormControl>
                        <TextField 
                            helperText={ ( props.type === TEXT_INPUTS[ 0 ] ) ? `${ props.value.length }/${ ADDITIONAL_PROPS.longText.inputProps.maxLength }` : null }
                            label={ props.label }
                            name={ props.dataKey }
                            onChange={ props.onChange }
                            value={ props.value }
                            { ...ADDITIONAL_PROPS[ props.type ] } /> 
                    </FormControl>:
                    null
            }
            {
                // image upload
                MULTIPART_INPUTS.includes( props.type ) ?
                    <div className="coe__additionalInformation__photo">
                        {
                            loading ?
                                <CircularProgress /> :
                                <FormControl className="coe__additionalInformation__photo__img">
                                    <Collapse in={ !hasData }>
                                        <Alert severity="warning">
                                            <AlertTitle>{ labels.noPornTitle }</AlertTitle>
                                            { labels.noPornBody }
                                        </Alert>
                                    </Collapse>
                                    {
                                        props.value ?
                                            <img src={ props.value } alt={ props.dataKey } /> :
                                            null
                                    }
                                </FormControl>
                        }
                        <div>
                            <Stack className="coe__additionalInformation__photo__controls">
                                <Button aria-label="Upload" component="label">
                                    <UploadFileIcon />
                                    <input hidden accept="image/*" multiple onChange={ handleUpload } type="file" />
                                </Button>
                                <Collapse in={ hasData }>
                                    <Button aria-label="Remove" color="error" onClick={ clearUpload }>
                                        <RemoveCircleOutlineIcon />
                                    </Button>
                                </Collapse>
                            </Stack>
                        </div>
                    </div> :
                    null
                    
            }
        </>
    )

}

AdditionalInformation.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
    type: PropTypes.string.isRequired,
    value: PropTypes.string
}

export default AdditionalInformation;